var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0.833252V8.16659M14.6666 6.03325V2.96659C14.6666 2.21985 14.6666 1.84648 14.5213 1.56126C14.3935 1.31038 14.1895 1.10641 13.9386 0.978577C13.6534 0.833252 13.28 0.833252 12.5333 0.833252H5.41196C4.43764 0.833252 3.95048 0.833252 3.55701 1.01154C3.21022 1.16868 2.91549 1.42153 2.70745 1.7404C2.4714 2.10218 2.39732 2.58368 2.24917 3.54667L1.90045 5.81333C1.70505 7.08346 1.60735 7.71852 1.79582 8.21267C1.96125 8.64638 2.27239 9.00905 2.6759 9.2385C3.13564 9.49992 3.77818 9.49992 5.06324 9.49992H5.59995C5.97332 9.49992 6.16001 9.49992 6.30261 9.57258C6.42806 9.6365 6.53004 9.73848 6.59396 9.86392C6.66662 10.0065 6.66662 10.1932 6.66662 10.5666V12.5227C6.66662 13.4306 7.40262 14.1666 8.31051 14.1666C8.52706 14.1666 8.7233 14.0391 8.81125 13.8412L11.0518 8.80004C11.1537 8.57075 11.2046 8.45611 11.2852 8.37204C11.3563 8.29774 11.4438 8.24092 11.5406 8.20604C11.6501 8.16659 11.7756 8.16659 12.0265 8.16659H12.5333C13.28 8.16659 13.6534 8.16659 13.9386 8.02126C14.1895 7.89343 14.3935 7.68946 14.5213 7.43857C14.6666 7.15336 14.6666 6.77999 14.6666 6.03325Z",
    stroke: "#B28C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.28a6bf2a60d0f87fb2cd1fba96a1e427.svg";
export { ForwardRef as ReactComponent };